import styled from '@emotion/styled';
import React from 'react';

import Arrange from '../arrange/arrange';
import { SvgAlertTriangle } from '../icon/available-icons/alert-triangle';
import Icon from '../icon/icon';
import Text from '../text/text';

interface ErrorContainerProps {
  children: React.ReactNode;
  errorActive: boolean;
  errorMessage?: string;
}

// the border below is a stand-alone component to avoid messing with the layout of the children
// the calculations in width, height, top, and left are to add padding between the border and the children
// pointer-events: none is to allow the children to be clickable

const ErrorContainerBorder = styled.div`
  position: relative;
  ::before {
    content: '';
    width: calc(100% + var(--lns-space-medium));
    height: calc(100% + var(--lns-space-medium));
    position: absolute;
    top: calc(-1 * var(--lns-space-small));
    left: calc(-1 * var(--lns-space-small));
    outline: 1px solid var(--lns-color-danger);
    border-radius: var(--lns-radius-large);
    pointer-events: none;
  }
`;

const ErrorContainer = ({
  children,
  errorActive,
  errorMessage = "Oops, that didn't work. Try again.",
}: ErrorContainerProps) => {
  if (!errorActive) {
    return <>{children}</>;
  }

  return (
    <ErrorContainerBorder>
      <Arrange autoFlow="row" gap="small">
        {children}
        {errorMessage ? (
          <Arrange gap="xsmall">
            <Icon icon={<SvgAlertTriangle />} size={2} color="danger" />
            <Text size="body-sm" color="danger">
              {errorMessage}
            </Text>
          </Arrange>
        ) : null}
      </Arrange>
    </ErrorContainerBorder>
  );
};

export default ErrorContainer;
